<template>
  <div id="perfume_anima" class="anima-shell relativeItem">
    <!--线条动画-->
    <div id="main"></div>
    <div id="line"></div>
    <div id="text"></div>
  </div>
</template>

<script>
import lottie from "lottie-web";

export default {
  name: "perfume_anima",
  data() {
    return {};
  },
  methods: {
    /**动画初始化 */
    init_anim() {
      //线条动画
      lottie.loadAnimation({
        container: document.getElementById("line"),
        renderer: "svg", // 渲染方式:svg、canvas
        loop: false, //循环播放，默认：false
        autoplay: true, //自动播放 ，默认true
        path: "/perfume_line/data.json",
      });

      //文字动画
      lottie.loadAnimation({
        container: document.getElementById("text"),
        renderer: "svg", // 渲染方式:svg、canvas
        loop: false, //循环播放，默认：false
        autoplay: true, //自动播放 ，默认true
        path: "/perfume_text/data.json",
      });

      //主体循环动画
      lottie.loadAnimation({
        container: document.getElementById("main"),
        renderer: "svg", // 渲染方式:svg、canvas
        loop: true, //循环播放，默认：false
        autoplay: true, //自动播放 ，默认true
        path: "/perfume_main/data.json",
      });
    },
  },
  mounted: function () {
    this.init_anim();
  },
};
</script>

<style scoped>
.anima-shell {
  /* width: 100%;
  position: absolute;
  top: 0;
  left: 0; */
  z-index: 1;
}
#line {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 1;
}
#text {
  position: absolute;
  width: 60%;
  right: 0;
  top: 18%;
  z-index: 2;
}
</style>
